type Props = {
  docked: boolean;
  width: number;
  overlayWidth?: number;
  white?: boolean;
  onScrimClick: () => void;
  children: React.ReactNode;
};

/**
 * Shared shell for the right-side panels: a detached card docked next to the
 * board on desktop, a slide-in overlay with a scrim on smaller screens.
 */
const SidePanel = ({ docked, width, overlayWidth, white, onScrimClick, children }: Props) => {
  const surface = white ? 'bg-brand-white border border-grey-medium' : 'bg-brand-white';

  if (docked) {
    return (
      <aside className={`flex-none flex flex-col min-h-0 rounded mt-0.5 mr-4 mb-4 ${surface}`} style={{ width }}>
        {children}
      </aside>
    );
  }

  return (
    <>
      <aside
        className={`kds-panel-in absolute top-0 right-0 bottom-0 z-50 flex flex-col min-h-0 shadow-[0_0_30px_rgba(0,0,0,0.15)] ${surface}`}
        style={{ width: overlayWidth ?? width, maxWidth: '88%' }}
      >
        {children}
      </aside>
    </>
  );
};

export default SidePanel;
